import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { useDataContext } from '../../context/data';
import translations from '../../constants/translations.json';

const flags = {
  da: '🇩🇰',
  no: '🇳🇴',
  en: '🇬🇧',
  de: '🇩🇪',
  sv: '🇸🇪',
  es: '🇪🇸',
};

const LanguageSelector = () => {
  const { language, setLanguage } = useDataContext();

  useEffect(() => {
    const cachelang = window.localStorage.getItem('user_lang');
    setLanguage(cachelang || 'en');
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    window.localStorage.setItem('user_lang', lang);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {Object.entries(translations)?.map(([key, value]) => (
        <button
          key={key}
          onClick={() => changeLanguage(key)}
          className={`flex items-center gap-2 py-2.5 px-4 rounded-[10px] cursor-pointer transition-all duration-200 text-[13px] ${
            language === key
              ? 'border-2 border-primary bg-primary/5 font-semibold text-[#1a1a1a]'
              : 'border border-gray-200 bg-white font-normal text-gray-500'
          }`}
        >
          <span className="text-lg">{flags[key] || '🌐'}</span>
          {value.language_name}
          {language === key && <i className="fas fa-check text-primary text-[11px] ml-1" />}
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
